import { TFunction } from "i18next";
import { SystemEventParentType } from "../domain/enums/SystemEventParentTypeEnum";
import { SystemEventType } from "../domain/enums/SystemEventTypeEnum";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";

export interface SystemEventsSearchFiltersDTO {
    parentId?: string;
    parentType?: SystemEventParentType;
    eventType?: number;
}

export const systemEventsSearchFiltersFields: Fields<SystemEventsSearchFiltersDTO> = {
    parentId: {
        min: 1,
        max: 128,
        placeholderKey: "console.systemEvents.filters.parentIdPlaceholder",
        type: "text",
        optional: true,
        initial: "",
    },
    parentType: {
        min: 0,
        max: 10,
        placeholderKey: "console.systemEvents.filters.parentTypePlaceholder",
        type: "number",
        optional: true,
        initial: "",
    },
    eventType: {
        min: 0,
        max: 200,
        placeholderKey: "console.systemEvents.filters.eventTypePlaceholder",
        type: "number",
        optional: true,
        initial: "",
    },
};

export const systemEventsSearchFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, systemEventsSearchFiltersFields);
};
